import endpoint from "@/api/endpoint";

export default {

    get(code){
        return window.axios.get(endpoint+'/api/banners/'+code);
    }

}
